import { RecurringShiftInstanceDto } from "../models/recurringShift/recurringShift";
import { RecurringShiftEditDto } from "../models/recurringShift/recurringShift";
import { apiCall } from "./apiClient";

export const createRecurringShiftInstance = async(dto: RecurringShiftInstanceDto) => {
    return await apiCall<void>("RecurringShifts/instance", "POST", dto);
};

export const editRecurringShift = async(id: string, dto: RecurringShiftEditDto) => {
    return await apiCall<void>(`RecurringShifts/${id}`, "PUT", dto);
};

export const deleteRecurringShift = async(id: string) => {
    return await apiCall<void>(`RecurringShifts/${id}`, "DELETE");
};
